<template>
  <div class="third data-api-details">
    <div class="third-formOne cards-XQ">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content">应用卡片详情》{{otherForm.cardName}}</span>
        </div>
      </div>
      <el-form
        :model="otherForm"
        ref="otherForm"
        label-width="86px"
        :show-message="false"
      >
        <div class="formOne-forms" style="margin-top: 57px;">
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>
            <div class="one-list">
              <div class="list-one-line">
                <el-form-item label="卡片名称:">
                  <span class="single-row">{{otherForm.cardName}}</span>
                </el-form-item>
              </div>
              <div class="list-one-line">
                <el-form-item label="当前包名:">
                  <span class="single-row">{{otherForm.packageName}}</span>
                </el-form-item>
              </div>
              <div class="list-one-line">
                <el-form-item label="当前版本:">
                  <span class="single-row">{{otherForm.version}}</span>
                </el-form-item>
              </div>
              <div class="list-two-line">
                <el-form-item label="卡片顺序:">
                  <span class="multi-rows">{{otherForm.cardSort}}</span>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">授权信息</span>
              </div>
            </div>
            <div class="one-list">
              <div class="list-one-line">
                <el-form-item label="管理员:">
                  <span class="single-row">
                    <template v-for="(row, index) in managerList">
                      <!-- <key-value-span :key="index + row"
                        v-model="row.adminId"
                        methods="post"
                        dictUrl="/api/blade-workbench/eduDeptInfo/getTeacherNameAndTeacherId"
                        :needSearch="true"
                      ></key-value-span>
                      <template v-if="index !== managerList.length-1">
                        <span :key="index + row + 'span'">,</span>
                      </template> -->
                      <span :key="index + row + 'span'">{{row.adminName}}
                        <template v-if="index !== managerList.length-1">
                          <span>，</span>
                        </template>
                      </span>
                    </template>
                  </span>
                </el-form-item>
              </div>
              <div class="list-two-line">
                <el-form-item label="授权角色:">
                  <span class="multi-rows">{{otherForm.roleName}}</span>
                </el-form-item>
              </div>
              <div class="list-two-line">
                <el-form-item label="授权标签:">
                  <span class="multi-rows">{{otherForm.lableName}}</span>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title" style="padding-bottom:0;">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">升级记录</span>
              </div>
            </div>
            <div class="one-list">
              <div class="third-one" style="padding-left:0px;padding-top:0;">
                <div class="third-do-btn">
                  <div class="do-btn-right">
                    <div class="do-btn-check">
                      <span
                        class="btn-check-span"
                        style="color:#BDC0C6;"
                      >仅可查看最近30个版本</span>
                    </div>
                  </div>
                </div>
              </div>
              <el-table
                class="third-tableThree tableThree-viewDetail"
                :data="otherForm.cardUpdateList"
                empty-text="暂无字段，请创建"
                border
                stripe
                v-loading="loading"
              >
                <el-table-column prop="version" label="版本名称" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="packageName" label="包名" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="updateNote" label="更新说明" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="updateTime" label="升级时间" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column
                  prop="appKey"
                  label="操作"
                  :show-overflow-tooltip="true"
                  min-width="100px"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button @click="download(scope.row.id)" type="text" size="small">下载版本包</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { selectCards, download } from "@/api/cardsManage/cards";
import { unencrypt } from "@/utils/encrypt";
export default {
  name: "formSeven",
  props: ["ID"],
  components: {},
  data() {
    return {
      loading: false,
    //   rules: {
    //     name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
    //     sex: [{ required: true, message: "请选择性别", trigger: "change" }],
    //     keyId: [{ required: true, message: "请输入工号", trigger: "blur" }],
    //     tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }]
    //   },
      otherForm: {
        id: "", //卡片id
        cardName: "", //卡片名称
        cardSort: 1, //卡片顺序
        packageName: "", //当前包名
        version: "", //当前版本
        admin: "", //管理员
        roleId: "", //授权角色
        lableId: "", //授权标签
        roleName: "",
        lableName: "",
        cardUpdateList: [
          //升级记录
        //   {
        //     id: "", //卡片升级记录id
        //     platformApplyCardId: "", //卡片id
        //     path: "", //升级包下载地址
        //     packageName: "", //升级包名称
        //     version: "", //版本名称
        //     updateNote: "", //更新说明
        //     createTime: "", //创建时间
        //     updateTime: "" //更新时间
        //   },
        //   {
        //     id: "",
        //     platformApplyCardId: "",
        //     path: "",
        //     packageName: "",
        //     version: "",
        //     updateNote: "",
        //     createTime: "",
        //     updateTime: ""
        //   }
        ]
      },
      tableData: [],
      managerList: []
    };
  },
  created() {
    console.log("这是IDDDDDD", this.ID);
    if (this.ID !== "") {
      //   console.log("看看我的hostURL", window.location.origin);
      this.BJselect();
      //   this.customerSelect();
    }
  },
  methods: {
    //返回
    goBack() {
      this.$emit("backHome");
    },
    //详情查询
    BJselect() {
      try {
        this.loading = true
        const params = this.ID; //api的id;
        selectCards(params).then(res => {
          this.loading = false
          const data = res.data;
          console.log("这是卡片管理获取详情接口", data);
          if (data.status === 1000) {
            this.otherForm = data.result;
            if (this.otherForm.admins.length !== 0) {
              this.managerList = this.otherForm.admins
            } else {
              this.managerList = []
            }
          }
        });
      } catch (err) {
        this.loading = false
        console.log(err);
      }
    },
    //下载备份
    download(url) {
    //   this.$downLoadFile(url);
      try {
        const params = url; //id
        console.log("params", params);
        download(params).then(res => {
          const data = res.data;
          console.log("这是下载备份接口", data);
          if (data.status === 1000) {
            window.open(unencrypt(data.result))
            // this.$downLoadFile(data.result);
          } else {
            this.$message.error(data.msg);
          }
        });
        // this.$downLoadFile(url, params);
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
<style lang="scss">
.data-api-details {
  .multi-rows,
  .single-row {
    display: inline-block;
    font-size: 12px;
    padding-left: 8px;
    color: #828d9a;
  }
  .single-row {
    width: 292px;
  }
  .multi-rows {
    width: 676px;
  }
  .multi-rows-fz {
    display: inline-block;
    font-size: 12px;
    padding-left: 8px;
    color: #828d9a;
  }
  .right-todo {
    font-size: 12px;
    padding-left: 8px;
    color: #2d8cf0;
    cursor: pointer;
  }
}
.third {
  .cards-XQ {
    height: 100vh;
  }
}
</style>
